import { bcs } from "@mysten/sui/bcs";
import { Transaction } from "@mysten/sui/transactions";
import { normalizeSuiAddress } from "@mysten/sui/utils";
import { lock } from "../kiosk.js";
async function resolveRoyaltyRule(params) {
  const {
    kioskClient,
    transaction: tx,
    itemType,
    price,
    packageId,
    transferRequest,
    policyId
  } = params;
  const feeTx = new Transaction();
  feeTx.moveCall({
    target: `${packageId}::royalty_rule::fee_amount`,
    typeArguments: [itemType],
    arguments: [feeTx.object(policyId), feeTx.pure.u64(price || "0")]
  });
  const policyObj = tx.object(policyId);
  const { results } = await kioskClient.client.devInspectTransactionBlock({
    sender: tx.getData().sender || normalizeSuiAddress("0x0"),
    transactionBlock: feeTx
  });
  let amount = null;
  if (results) {
    const returnedAmount = results?.[0].returnValues?.[0]?.[0];
    if (returnedAmount) {
      amount = BigInt(bcs.U64.parse(new Uint8Array(returnedAmount)));
    }
  }
  if (!amount) {
    [amount] = tx.moveCall({
      target: `${packageId}::royalty_rule::fee_amount`,
      typeArguments: [itemType],
      arguments: [policyObj, tx.pure.u64(price || "0")]
    });
  }
  const feeCoin = tx.splitCoins(tx.gas, [amount]);
  tx.moveCall({
    target: `${packageId}::royalty_rule::pay`,
    typeArguments: [itemType],
    arguments: [policyObj, transferRequest, feeCoin]
  });
}
function resolveKioskLockRule(params) {
  const {
    transaction: tx,
    packageId,
    itemType,
    kiosk,
    kioskCap,
    policyId,
    purchasedItem,
    transferRequest
  } = params;
  if (!kiosk || !kioskCap) throw new Error("Missing Owned Kiosk or Owned Kiosk Cap");
  lock(tx, itemType, kiosk, kioskCap, policyId, purchasedItem);
  tx.moveCall({
    target: `${packageId}::kiosk_lock_rule::prove`,
    typeArguments: [itemType],
    arguments: [transferRequest, tx.object(kiosk)]
  });
}
function resolvePersonalKioskRule(params) {
  const { transaction: tx, packageId, itemType, kiosk, transferRequest } = params;
  if (!kiosk) throw new Error("Missing owned Kiosk.");
  tx.moveCall({
    target: `${packageId}::personal_kiosk_rule::prove`,
    typeArguments: [itemType],
    arguments: [tx.object(kiosk), transferRequest]
  });
}
function resolveFloorPriceRule(params) {
  const { transaction: tx, packageId, itemType, policyId, transferRequest } = params;
  tx.moveCall({
    target: `${packageId}::floor_price_rule::prove`,
    typeArguments: [itemType],
    arguments: [tx.object(policyId), transferRequest]
  });
}
export {
  resolveFloorPriceRule,
  resolveKioskLockRule,
  resolvePersonalKioskRule,
  resolveRoyaltyRule
};
//# sourceMappingURL=resolve.js.map
